const tl = {
  letsgo: {
    de: "Los geht's!",
    en: "Let's go!",
    it: "Andiamo!"
  },
  chooselanguage: {
    de: "Wähle deine Sprache",
    en: "Choose your language",
    it: "Scegli la tua lingua"
  },
  consenttext: {
    de: "Ich stimme der Datenschutzerklärung zu.",
    en: "By clicking start I accept the Privacy Policy.",
    it: "Accetto l'informativa sulla privacy."
  },
  moreinfo: {
    de: "Mehr Infos",
    en: "More info",
    it: "Ulteriori informazioni"
  },
  stickers: {
    de: "Mein Sammelpass",
    en: "My Stickers",
    it: "I miei adesivi"
  },
  firststickertext: {
    de: "Gehe einen Weg, um deinen ersten Sticker zu sammeln!",
    en: "Finish a trail to collect your first sticker!",
    it: "Completa un percorso per raccogliere il tuo primo adesivo!"
  },
  badgedatetext: {
    de: "Geschafft am",
    en: "Achieved on",
    it: "Completato il"
  },
  youdidit: {
    de: "Geschafft!",
    en: "You did it!",
    it: "Ce l'hai fatta!"
  },
  youdidittext: {
    de: "Gratulation! Du hast den Weg am ${1} absolviert.",
    en: "Congratulations! You completed the trail on ${1}",
    it: "Congratulazioni! Hai completato il percorso il ${1}"
  },
  changelanguage: {
    de: "Sprache ändern",
    en: "Change language",
    it: "Cambia lingua"
  },
  trails: {
    de: "Wege",
    en: "Trails",
    it: "Sentieri"
  },
  trail_singular: {
    de: "Weg",
    en: "Trail",
    it: "Sentiero"
  },
  stations: {
    de: "Stationen",
    en: "stations",
    it: "Stazioni"
  },
  station_singular: {
    de: "Station",
    en: "station",
    it: "Stazione"
  },
  hours: {
    de: "Stunden",
    en: "hours",
    it: "ore"
  },
  hour_singular: {
    de: "Stunde",
    en: "hour",
    it: "ora"
  },
  difficulty: {
    de: ["Leicht", "Mittel", "Schwer"],
    en: ["Easy", "Medium", "Hard"],
    it: ["Facile", "Medio", "Difficile"]
  },
  map: {
    de: "Karte",
    en: "Map",
    it: "Mappa"
  },
  list: {
    de: "Liste",
    en: "List",
    it: "Lista"
  },
  startnow: {
    de: "Jetzt starten",
    en: "Start now",
    it: "Inizia ora"
  },
  startagain: {
    de: "Nochmal starten",
    en: "Start again",
    it: "Ricomincia"
  },
  arrival: {
    de: "Startpunkt & Anreise",
    en: "Starting point & arrival",
    it: "Punto di partenza e arrivo"
  },
  route: {
    de: "Route anzeigen",
    en: "Show route",
    it: "Mostra percorso"
  },
  reload: {
    de: "Neu laden",
    en: "Reload",
    it: "Ricarica"
  },
  poi_water: {
    de: "Trinkwasser",
    en: "Drinking water",
    it: "Acqua potabile"
  },
  poi_restaurant: {
    de: "Restaurant",
    en: "Restaurant",
    it: "Ristorante"
  },
  poi_toilet: {
    de: "Toilette",
    en: "Toilet",
    it: "Servizi igienici"
  },
  poi_photopoint: {
    de: "Fotopoint",
    en: "Photopoint",
    it: "Punto foto"
  },
  poi_pin: {
    de: "Markierung",
    en: "Marking",
    it: "Marcatura"
  },
  poi_bench: {
    de: "Sitzbank",
    en: "Bench",
    it: "Panca"
  },
  poi_info: {
    de: "Info",
    en: "Info",
    it: "Info"
  },
  opennow: {
    de: "Jetzt öffnen",
    en: "Open now",
    it: "Aperto ora"
  },
  openagain: {
    de: "Nochmal öffnen",
    en: "Open again",
    it: "Apri di nuovo"
  },
  nolocation: {
    de: "Kein Standort",
    en: "No location",
    it: "Nessuna posizione"
  },
  unlockdistancetext: {
    de: "Freischalten in",
    en: "Unlock in",
    it: "Sblocca tra"
  },
  moveclosertounlock: {
    de: "Bewege dich zur Station",
    en: "Move closer to unlock",
    it: "Avvicinati per sbloccare"
  },
  stationdistanceaway: {
    de: "${1} entfernt",
    en: "${1} away",
    it: "${1} di distanza"
  },
  locationhintlabel: {
    de: "Hinweis:",
    en: "Hint:",
    it: "Suggerimento:"
  },
  success_headline: {
    de: "Geschafft!",
    en: "You did it!",
    it: "Fatto!"
  },
  success_text: {
    de: "Glückwunsch, du hast alle Stationen des Weges '${1}' geschafft!",
    en: "Congratulations, you have found all stations of the '${1}' trail!",
    it: "Congratulazioni, hai trovato tutte le stazioni del percorso '${1}'!"
  },
  collect_sticker: {
    de: "Sticker einsammeln",
    en: "Collect sticker",
    it: "Raccogli lo sticker"
  },
  feedback_headline: {
    de: "Wie hat dir der Weg gefallen?",
    en: "How did you like this trail?",
    it: "Come ti è piaciuto questo percorso?"
  },
  feedback_improve: {
    de: "Danke! Was können wir verbessern?",
    en: "Thanks! What could we improve?",
    it: "Grazie! Cosa possiamo migliorare?"
  },
  feedback_fivestars: {
    de: "Das freut uns! Was hat dir am besten gefallen?",
    en: "We love to hear that! What did you like the most?",
    it: "Siamo felici di sentirlo! Cosa ti è piaciuto di più?"
  },
  skip: {
    de: "Überspringen",
    en: "Skip",
    it: "Salta"
  },
  sendfeedback: {
    de: "Feedback abgeben",
    en: "Send feedback",
    it: "Invia feedback"
  },
  next: {
    de: "Weiter",
    en: "Next",
    it: "Prossimo"
  },
  continue: {
    de: "Fortfahren",
    en: "Continue",
    it: "Continuare"
  },
  station_success: {
    de: "Du hast die Station ${1} geschafft, weiter so!",
    en: "You have completed station ${1}, keep it up!",
    it: "Hai completato la stazione ${1}, continua così!"
  },
  stationsuccess_count: {
    de: "${1} von ${2} Stationen geschafft!",
    en: "${1} of ${2} stations completed!",
    it: "${1} su ${2} stazioni completate!"
  },
  viewagain: {
    de: "Nochmal ansehen",
    en: "View again",
    it: "Guarda di nuovo"
  },
  imagecredit: {
    de: "Bild",
    en: "Image",
    it: "Foto"
  },
  sharewithfriends: {
    de: "Mit Freunden teilen",
    en: "Share with friends",
    it: "Condividi con amici"
  },
  usephoto: {
    de: "Foto aufnehmen",
    en: "Take photo",
    it: "Scattare una foto"
  },
  removephoto: {
    de: "Foto entfernen",
    en: "Remove photo",
    it: "Rimuovi foto"
  },
  shareimage: {
    de: "Bild teilen",
    en: "Share image",
    it: "Condividi immagine"
  },
  errorheadline: {
    de: "Oje, Seite nicht gefunden",
    en: "Oops, page not found",
    it: "Ops, pagina non trovata"
  },
  errorbutton: {
    de: "Zurück zum Start",
    en: "Back to home",
    it: "Torna alla home"
  },
  tapholdtosave: {
    de: "Bild gedrückt halten zum Speichern",
    en: "Tap and hold the image to save",
    it: "Tieni premuto sull'immagine per salvare"
  },
  socialshareprivacy: {
    de: "Deine Fotos werden nirgends hochgeladen oder gespeichert",
    en: "Your photos will not be uploaded or saved anywhere.",
    it: "Le tue foto non vengono salvate da nessuna parte."
  },
  socialshareerrormessage: {
    de: "Das Bild konnte nicht geteilt werden. Versuchen Sie, das Bild zu tippen und gedrückt zu halten, um es zu speichern.",
    en: "Could not share the image. Try to tap and hold the image to save it.",
    it: "Impossibile condividere l'immagine. Prova a toccare e tenere premuta l'immagine per salvarla."
  },
  taptocollect: {
    de: "Tippe zum Einsammeln",
    en: "Tap to collect",
    it: "Tocca per raccogliere"
  },
  sendfeedback: {
    de: "Feedback senden",
    en: "Send Feedback",
    it: "Invia feedback"
  },
  choosestartingpoint: {
    de: "Wähle deinen Startpunkt",
    en: "Choose your starting point",
    it: "Scegli il tuo punto di partenza"
  },
  startfromhere: {
    de: "Von hier starten",
    en: "Start from here",
    it: "Inizia da qui"
  },
  badge_singular: {
    de: "Abzeichen",
    en: "badge",
    it: "distintivo"
  },
  badge_plural: {
    de: "Abzeichen",
    en: "badges",
    it: "distintivi"
  },
  progress_of: {
    de: "von",
    en: "of",
    it: "di"
  },
  getnow: {
    de: "Jetzt abholen!",
    en: "Get it now!",
    it: "Prendilo ora!"
  },
  myrewards: {
    de: "Meine Belohnungen",
    en: "My rewards",
    it: "Le mie ricompense"
  },
  voucher_redeem_confirm: {
    de: "Möchtest du diesen Gutschein wirklich einlösen?",
    en: "Do you really want to redeem this voucher?",
    it: "Vuoi davvero riscattare questo voucher?"
  },
  voucher_redeemed: {
    de: "Eingelöst",
    en: "Redeemed",
    it: "Riscattato"
  },
  scantoviewphone: {
    de: "QR-Code scannen - auf deinem Smartphone ansehen!",
    en: "Scan QR Code - view on your mobile phone!",
    it: "Scansiona il codice QR - guarda sul tuo smartphone!"
  },
  downloadcontent: {
    de: "Für offline speichern",
    en: "Save for offline",
    it: "Salva offline"
  },
  recommended: {
    de: "Empfohlen",
    en: "Recommended",
    it: "Consigliato"
  },
  percentloaded: {
    de: "geladen",
    en: "loaded",
    it: "caricato"
  },
  contentloaded: {
    de: "Inhalte geladen",
    en: "Content loaded",
    it: "Contenuti scaricati"
  },
  downloadinfo: {
    de: "Lade dir die Inhalte wie Videos, Audios und Spiele vorab herunter, damit du auch bei schwachem Internet am Weg alles flüssig erlebst.",
    en: "Download content like videos, audios, and games in advance so that everything runs smoothly even with poor internet on the go.",
    it: "Scarica in anticipo contenuti come video, audio e giochi, così tutto funzionerà senza problemi anche con una connessione internet debole durante il percorso."
  },
  downloaderror_retry: {
    de: "Die Inhalte konnten nicht vollständig geladen werden. Bitte versuche es mit einer stabilen Verbindung erneut.",
    en: "The content could not be fully loaded. Please try again with a stable connection.",
    it: "Non è stato possibile scaricare tutti i contenuti. Riprova con una connessione stabile."
  },
  deletedownload: {
    de: "Willst du die geladenen Inhalte wieder löschen?",
    en: "Are you sure you want to delete the downloaded content?",
    it: "Sei sicuro di voler eliminare i contenuti scaricati?"
  },
  delete_downloaded_content: {
    de: "Geladene Inhalte löschen",
    en: "Delete downloaded content",
    it: "Elimina contenuti scaricati"
  },
  delete_downloaded_content_confirm: {
    de: "Möchtest du alle geladenen Inhalte löschen?",
    en: "Do you want to delete all downloaded content?",
    it: "Vuoi eliminare tutti i contenuti scaricati?"
  },
  delete_downloaded_content_error: {
    de: "Die geladenen Inhalte konnten nicht gelöscht werden. Bitte versuche es erneut.",
    en: "Downloaded content could not be deleted. Please try again.",
    it: "Non è stato possibile eliminare i contenuti scaricati. Riprova."
  },
  check: {
    de: "Überprüfen",
    en: "Check",
    it: "Verifica"
  },
  game_madeit: {
    de: "Geschafft!",
    en: "Made it!",
    it: "Fatto!"
  },
  showhint: {
    de: "Tipp anzeigen",
    en: "Show hint",
    it: "Mostra suggerimento"
  },
  hints: {
    de: "Tipps",
    en: "Hints",
    it: "Suggerimenti"
  },
  video_subtitles_on: {
    de: "Untertitel: ein",
    en: "Subtitles: on",
    it: "Sottotitoli: on"
  },
  video_subtitles_off: {
    de: "Untertitel: aus",
    en: "Subtitles: off",
    it: "Sottotitoli: off"
  },
  camera_permission_denied: {
    de: "Kamera ist deaktiviert. Gehe in deine Handy-Einstellungen, erlaube deiner App (zB. Chrome, Safari) den Kamerazugriff und lade die Seite neu.",
    en: "Camera access is disabled. Open your phone settings, allow camera access for your app (for example Chrome or Safari), and reload the page.",
    it: "L'accesso alla fotocamera e disattivato. Apri le impostazioni del telefono, consenti l'accesso alla fotocamera per la tua app (ad esempio Chrome o Safari) e ricarica la pagina."
  }

};

export default tl;
